import {
  AfterViewInit,
  Component,
  OnDestroy,
  OnInit,
  ViewChild,
  ViewEncapsulation
} from '@angular/core';
import {CalendarOptions, DateRangeInput, DateSelectArg, EventApi, EventInput} from '@fullcalendar/core';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import interactionPlugin from '@fullcalendar/interaction';
import listPlugin from '@fullcalendar/list';
import multiMonthPlugin from '@fullcalendar/multimonth';
import bootstrap5Plugin from '@fullcalendar/bootstrap5';
import deLocale from '@fullcalendar/core/locales/de';
import CalendarService from "../../../api/calendar/calendar.service";
import {BehaviorSubject, Observable, Subscription} from "rxjs";
import ArtistContext from "../../util/artist.context";
import {EventFormComponent, EventFormDialogModel} from "../../parts/event/event-form/event-form.component";
import CooperationEventModel from "../../../model/cooperationEvent.model";
import {MatDialog} from "@angular/material/dialog";
import {MatSnackBar} from "@angular/material/snack-bar";
import {FullCalendarComponent} from "@fullcalendar/angular";
import {first} from "rxjs/operators";
import EventService from "../../../api/event/event.service";
import ArtistModel from "../../../model/artist.model";
import {EventTypeDialogComponent} from "../../dialogs/event-type-dialog/event-type-dialog.component";
import {PrivateEventComponent, PrivateEventFormDialogModel} from "../../parts/private-event/private-event.component";
import EventModel from "../../../model/event.model";
import VacationModel from "../../../model/vacation.model";
import {MatSelect} from "@angular/material/select";
import {VacationComponent, VacationFormDialogModel} from "../../parts/vacation/vacation.component";
import AvatarGenerator from "../../util/avatarGenerator";
import UserService from "../../../api/user/user.service";
import UserModel from "../../../model/user.model";

@Component({
  selector: 'app-calendar',
  templateUrl: './calendar.component.html',
  styleUrls: ['./calendar.component.scss'],
  encapsulation: ViewEncapsulation.Emulated

})
export class CalendarComponent implements OnInit, OnDestroy, AfterViewInit{
  @ViewChild('fullcalendar') calendarCmp: FullCalendarComponent;

  viewOptions: Array<{ label: string, value: string }> = [
    { label: 'Tag', value: 'timeGridDay' },
    { label: 'Woche', value: 'timeGridWeek' },
    { label: 'Monat', value: 'dayGridMonth' },
    { label: 'Terminübersicht', value: 'listYear' }
  ];
  currentView = 'dayGridMonth';
  calendarOptions: CalendarOptions = {
    timeZone: 'local',
    weekends: true,
    editable: true,
    selectable: true,
    selectMirror: true,
    dayMaxEvents: false,
    eventDisplay: 'block',
    headerToolbar: {
      left: 'prev,next today title',
      right: 'customViewSwitcher'
    },
    customButtons: {
      customViewSwitcher: {
        text: this.currentView,
      }
    },
    height: 720,
    aspectRatio: 2.0,
    firstDay: 1,
    initialView: this.currentView,
    locale: deLocale,
    plugins: [dayGridPlugin, timeGridPlugin, interactionPlugin, listPlugin, multiMonthPlugin],
    eventClick: (arg) => this.onEventClick(arg.event.extendedProps),
    datesSet: this.handleMonthNavigation.bind(this),
    eventsSet: this.handleEvents.bind(this),
    // themeSystem: 'bootstrap5',
    dayCellDidMount: this.handleDayCellMount.bind(this),
    events: [],
  };
  isPopoverVisible = false;
  popoverDate: string;
  popoverData: any[];

  private eventsSubject = new BehaviorSubject<any[]>([]);
  public events$ = this.eventsSubject.asObservable();

  private eventsSubscription: Subscription;
  private date: Date = new Date();
  private additionalInfo = {};
  public artist: ArtistModel;

  eventColor = 'rgba(40,167,69,0.6)';
  privateEventColor = 'rgba(0,123,255,0.6)';
  vacationColor = 'rgba(255,0,0,0.6)';

  eventTypes = ['event', 'private_event', 'vacation'];
  eventTypeList: any[] = [
    {name: 'Kooperation Termine', completed: true, color: this.eventColor, type:'event'},
    {name: 'Private Termine', completed: true, color:this.privateEventColor, type:'private_event'},
    {name: 'Influencer Urlaub', completed: true, color:this.vacationColor, type:'vacation'},
  ];
  public user$: Observable<UserModel>;

  dayEvents: { [date: string]: {} } = {};
  @ViewChild(MatSelect) matSelect: MatSelect;
  selectWidth: string = '144px';

  private loadingSubject = new BehaviorSubject<boolean>(false);
  public loading$ = this.loadingSubject.asObservable();
  constructor(private calendarService: CalendarService, private artistContext: ArtistContext, private dialog: MatDialog,
              private snackBar: MatSnackBar, private eventService: EventService, private userService: UserService) {
  }

  changeView() {
    this.calendarCmp.getApi().changeView(this.matSelect.value);
    this.currentView = this.matSelect.value;
    this.updateSelectWidth()

  }
  updateSelectWidth() {
    const selectedOption = this.matSelect.options.find(option => option.value === this.currentView);
    if (selectedOption) {
      let optionWidth = selectedOption._text.nativeElement.scrollWidth;
      this.selectWidth = `${optionWidth + 150}px`;
    }
  }

  ngOnInit(): void {
    this.user$ = this.userService.user$
  }
  ngAfterViewInit(): void {
    this.artistContext.selectedArtist$.subscribe(artist => {
      console.log('Artist changed ', artist);
      this.artist = artist;
      this.additionalInfo ={artist: artist?.id};
      this.loadData();
    });
  }

  loadData() {
    this.calendarOptions.events = [];
    this.loadingSubject.next(true);
    this.additionalInfo['eventTypes'] = this.eventTypes.join(',')
    this.additionalInfo['colors'] = { eventColor:this.eventColor, privateEventColor: this.privateEventColor, vacationColor:this.vacationColor };
    document.querySelectorAll('.fc-daygrid-day-frame .daygrid-more-link').forEach(el => el.remove());
    this.eventsSubscription = this.calendarService.list(this.date.getFullYear(), this.date.getMonth(), this.additionalInfo)
        .subscribe(result => {
          let eventsArray: EventInput[] = [];
          this.dayEvents = {};
          result.forEach((day) => {
            this.dayEvents[day.dayOfMonth] = day;
            eventsArray = [...eventsArray, ...(day.events.map(obj => ({...obj, allDay: true})))]
          });
          this.calendarOptions.events = eventsArray;


          const startDate = this.calendarCmp.getApi().view.currentStart;
          const endDate = this.calendarCmp.getApi().view.currentEnd;
          console.log("startDate : "+startDate+ " endDate:"+endDate)

          // Iterate through each day in the current view
          let currentDate = startDate;
          while (currentDate < endDate) {
            const dateStr = currentDate.toISOString().split('T')[0];
            const dayCell = document.querySelector(`[data-date="${dateStr}"]`);
            if (dayCell) {
              const arg = {
                dateStr: dateStr,
                el: dayCell,
              };
              this.dayCellDidMount(arg);
            }
            currentDate.setDate(currentDate.getDate() + 1);
          }

          this.loadingSubject.next(false);
        });
  }
  dayCellDidMount(arg: any) {
    const eventsOnDay = Array.isArray(this.calendarOptions.events)
        ? this.calendarOptions.events.filter((event: any) => {
          let eventDateStr = (event.date) ? event.date : event.start;
          eventDateStr = (new Date(eventDateStr)).toISOString().split('T')[0];
          return eventDateStr === arg.dateStr;
        })
        : [];
    const date = new Date(arg.dateStr);
    const day = date.getDate();
    const eventsForDay = this.dayEvents[day];
    if(eventsOnDay.length > 0 && eventsForDay && eventsForDay.hasOwnProperty('numberOfEvents')) {
      const moreCount = (eventsForDay['numberOfEvents'] + eventsForDay['numberOfPrivateEvent'] + eventsForDay['numberOfVacations']) - 2;
      if (moreCount > 0) {
        const moreLink = document.createElement('a');
        moreLink.className = "daygrid-more-link"
        moreLink.innerHTML = `+${moreCount} weitere`;
        moreLink.title = `Zeige ${moreCount} weitere Ereignisse`;
        moreLink.addEventListener('click', () => {
          this.loadingSubject.next(true);
          this.eventsSubscription = this.calendarService.dayEvents(this.date.getFullYear(), this.date.getMonth(), day, this.additionalInfo)
              .subscribe(result => {
                console.log(result);
                this.dayEvents[day] = result;
                this.popoverData = result;
                this.popoverDate = day + '.' + this.date.getMonth() + '.' + this.date.getFullYear();
                this.isPopoverVisible = true;
                this.loadingSubject.next(false);
              })
        });
        const dayFrame = arg.el.querySelector('.fc-daygrid-day-frame');
        if (dayFrame) {
          dayFrame.appendChild(moreLink);
        }
      } else {
        arg.el.querySelectorAll('.fc-daygrid-day-frame .daygrid-more-link').forEach(el => el.remove());
      }
    } else {
      arg.el.querySelectorAll('.fc-daygrid-day-frame .daygrid-more-link').forEach(el => el.remove());
    }
  }
  ngOnDestroy(): void {
    this.eventsSubscription.unsubscribe()
  }
  handleMonthNavigation(info: any) {
    const currentViewType = info.view.type;
    if (currentViewType === 'dayGridMonth') {
      this.date = info.end;
      this.loadData()
    }
  }


  onEventClick(info: any) {
    if(info.type === 'event') {
      this.eventService.show(info.eventId).pipe(first()).subscribe(result => {
        const dialogData = new EventFormDialogModel(result);

        const dialogRef = this.dialog.open(EventFormComponent, {
          data: dialogData
        });

        dialogRef.afterClosed().pipe(first()).subscribe(dialogResult => {
          if(dialogResult) {
            this.loadData();
            this.snackBar.open('Termin wurde bearbeitet');
          }
        });
      });
    } else if(info.type === 'private_event') {
      this.calendarService.showPrivateEvent(info.eventId).pipe(first()).subscribe(result => {
        this.privateEvent(result);
      })
    } else if(info.type === 'vacation') {
      this.calendarService.showVacation(info.eventId).pipe(first()).subscribe(result => {
        this.vacation(result);
      })
    }

  }
  handleEvents(events: EventApi[]) {
    const arr = this.eventsSubject.getValue()
    arr.push(events);
    this.eventsSubject.next(arr);
  }

  addEvent(date) {
    const dialogRef = this.dialog.open(EventFormComponent, {
      data: new EventFormDialogModel({
        cooperation: {artist: null, customer: null},
        title: '',
        deadline: new Date(date),
        briefing: '',
        conditions: '',
        coupon: '',
        fee: 0,
        state: 'open',
        fullday: true
      } as CooperationEventModel)
    });

    dialogRef.afterClosed().subscribe(dialogResult => {
      if (dialogResult) {
        this.loadData()
        this.snackBar.open('Termin wurde bearbeitet');
      }
    });
  }

  handleDayCellMount(arg: any) {
    if (arg.view.type === 'dayGridMonth') {
      const addButton = document.createElement('a');
      addButton.innerText = '+';
      addButton.title = "Event hinzufügen";
      addButton.classList.add('add-event-button');

      addButton.addEventListener('click', (event) => {
        this.openDialogEventType(arg.date);
      });
      arg.el.style.position = 'relative';
      arg.el.appendChild(addButton);
    }
  }

  closePopover(): void {
    this.isPopoverVisible = false;
  }

  openDialogEventType(date): void {
    const dialogRef = this.dialog.open(EventTypeDialogComponent, {
      data: {selectedDate: date},
      width: '300px',
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log(result);
      if(result) {
        if(result === 'event') {
          this.addEvent(date);
        } else if(result === 'privateEvent') {
          this.privateEvent({
            title: '',
            description: '',
            fromDate: date,
            toDate: date,
          } as EventModel);
        } else if(result === 'vacation') {
          this.vacation({
            title: '',
            destination: '',
            fromDate: date,
            toDate: date,
          } as VacationModel);
        }
      }
    });
  }

  privateEvent(event: EventModel) {
    const dialogRef = this.dialog.open(PrivateEventComponent, {
      data: new PrivateEventFormDialogModel(event)
    });

    dialogRef.afterClosed().subscribe(dialogResult => {
      if (dialogResult) {
        this.loadData()
        this.snackBar.open('Termin wurde bearbeitet');
      }
    });
  }

  vacation(event: VacationModel) {
    const dialogRef = this.dialog.open(VacationComponent, {
      data: new VacationFormDialogModel(event)
    });

    dialogRef.afterClosed().subscribe(dialogResult => {
      if (dialogResult) {
        this.loadData()
        this.snackBar.open('Termin wurde bearbeitet');
      }
    });
  }

  getAvatar(name) {
    if (name?.length >= 2) {
      return AvatarGenerator.generateForName(name.charAt(0) + ' ' + name.charAt(1));
    }
  }
  isManaged (checked) {
    console.log(checked);
    this.additionalInfo['managed'] = checked
    this.loadData();
  }
}